import { Dispatch, SetStateAction, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button, LinearProgress } from "@mui/material";
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function ViewHealthScores({
    open,
    onClose,
    setOpen,
}: ModalProps) {

    const [activeIndex, setActiveIndex] = useState<number | null>(null);

    const healthScores = [
        {
            label: "Compliance & Trust",
            value: 100,
            trend: "up",
            trendValue: "100",
            color: "green",
        },
        {
            label: "Order & Fulfillment Performance",
            value: 68,
            trend: "down",
            trendValue: "68",
            description: "3 delayed shipments last 30 days",
            color: "orange",
        },
        {
            label: "Customer Experience",
            value: 62,
            trend: "down",
            trendValue: "62",
            description: "8% of orders raised complaints (target <3%)",
            color: "purple",
        },
        {
            label: "Financial Reliability",
            value: 70,
            trend: "up",
            trendValue: "76",
            description: "Increased refund rate of 9% (target <5%)",
            color: "orange",
        },
        {
            label: "Engagement & Store Quality",
            value: 85,
            trend: "up",
            trendValue: "85",
            description: "Active product listings recently updated",
            color: "green",
        },
    ];

    return (
        <Modal className="modal health_score_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">

                    {/* Header */}
                    <div className="modal_title">
                        <div className="lt">
                            <h2>TechGadgets UAE</h2>
                            <p>VND-002 · Electronics</p>
                        </div>
                        <button className="btn-close" onClick={() => setOpen(false)}>
                            <CloseIcon />
                        </button>
                    </div>

                    <div className="health_summary">
                        <h4>
                            Health Score<span className="score">72.1 <i className="arrow">▼</i></span><span className="score_change">6.1 in 30 days</span>
                        </h4>

                        <p>
                            Health score dropped due to delayed shipments and increased refunds over
                            the last 30 days.
                        </p>
                    </div>

                    {/* Content */}
                    <div className="health_score_view">
                        {healthScores.map((item, index) => (
                            <div className="score_row" key={index}>
                                <div className="score_header">
                                    <label>{item.label}</label>

                                    <div className="score_meta">
                                        <span>{item.value}%</span>
                                        <span className={`trend ${item.trend}`}>
                                            {item.trendValue} <i className="arrow">{item.trend === "up" ? "▲" : "▼"}</i>
                                        </span>
                                    </div>
                                </div>

                                <div className="progress_flex">
                                    <p className="score_desc">{item.description}</p>
                                    <LinearProgress
                                        variant="determinate"
                                        value={item.value}
                                        className={`score_bar ${item.color}`}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="recommended_actions">
                        <h4>Recommended Actions</h4>

                        <ul>
                            <li>
                                <EmailOutlinedIcon />
                                Send an email warning to info@techgadgets.ae
                            </li>
                            <li>
                                <FlagOutlinedIcon />
                                Flag for follow-up review
                            </li>
                            <li>
                                <BlockOutlinedIcon />
                                Restrict promotional campaigns
                            </li>
                        </ul>
                    </div>

                    {/* Footer */}
                    <div className="footer_btn_flex right">
                        <Button className="btn btn_grey" onClick={() => setOpen(false)}>
                            Cancel
                        </Button>
                        <Button className="btn btn_primary">
                            Take Action
                        </Button>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
